// extracted by mini-css-extract-plugin
export default {"scrollTop":"scrolltopbutton_scrollTop__Uc9OL","fadeIn":"scrolltopbutton_fadeIn__7Zt7S"};